import React, { PureComponent } from "react";
import { Tree } from "antd";
import Icon from "@/components/Icon";
import styles from "./unitTree.module.less";

const { TreeNode } = Tree;
class UnitTree extends PureComponent {
    loop = (data) => {
        if (!(data && data.length > 0)) return ``;
        return data.map((item, index) => {
            if (item.type === `Organs`) {
                let titleSuf = `(机构:${item.organsCount},单位:${item.unitCount})`;
                return (
                    <TreeNode
                        key={item.id}
                        title={
                            <span style={{ lineHeight: 1.7 }}>
                                {item.name}
                                <span style={{ color: 'rgb(18,150,219)' }}>{titleSuf}</span>
                            </span>
                        }
                        dataRef={item}
                        treeType='unit'>
                        {item.childrenList && item.childrenList.length ? this.loop(item.childrenList) : ''}
                    </TreeNode>)

            } else {
                return (
                    <TreeNode
                        key={item.id}
                        title={
                            <span style={{ lineHeight: 1.7 }}>
                                <Icon.Prop style={{ fontSize: '0.18rem' }} type={"changgui-danwei"} />
                                {item.name}
                            </span>
                        }
                        dataRef={item}
                        treeType='unit'>
                    </TreeNode>
                );
            }
        });
    }

    render() {
        const { data, onSelect, value } = this.props;
        let par = {}
        if (data && data.id && data.id.length > 0) {
            par.defaultExpandedKeys= [data.id] ;
        }
        if (value && value.id && value.id.length > 0) {
            par.defaultSelectedKeys= [value.id] ;
        }
        return (
            <div className={styles.unitTypeTreeDiv}>
                <Tree
                    {...par}
                    onSelect={onSelect}
                >
                    {data ? this.loop([data], true) : ``}
                </Tree>
            </div >
        )
    }
}

export default UnitTree